module.exports = __webpack_public_path__ + "static/img/_dsc1297-1080p.807f7cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio1/_dsc1297-1080p.jpg
// module id = yADG
// module chunks = 0